<!-- <div *ngIf="showDetails" class="back-drop"></div> -->
  <!-- Container's width is {{ container.offsetTop }} 
  Container's Height is {{ container.offsetHeight }}
  Container's P width is {{ container.offsetParent.clientWidth }}
  Container's P Height is {{ container.offsetParent.clientHeight }} -->

<!-- <gp-milestone></gp-milestone> -->
<!-- <mat-menu  #menu="matMenu" class="md-lg-font m-lr30 p20" >
  <div  class="m-l15 m-t10" (click)="$event.stopPropagation();">
      <mat-form-field style="width:150px;" (click)="$event.stopPropagation();">
        <span matPrefix>$</span>
        <input matInput type="text" [formControlName]="'amount'" 
            placeholder="Goal Cost" 
            aria-label=""                                          
            NumbersOnly
            class="ip-right-align p-r5"/> 
    </mat-form-field>
  </div>
  <div class="m-r10 m-t10 p-t10 border-t-gray" >
    <button mat-raised-button color="basic" class="m-lr10">Cancel</button>
    <button mat-raised-button color="primary" (click)="createGoal();" class="saveButton m-l10">Save</button>
  </div>
</mat-menu> -->
<div *ngIf="!showDetails" class="flex-col-container m-t50">
  <div class="flex-col-center">    
    <!-- <mat-card [ngStyle]="{'background: linear-gradient(0.25turn,'+  goal.color +')'}" [ngClass]="goal.goalId?'activeGoal':'nonActiveGoal'" *ngFor="let goal of goals; let i = index" class="pointer m-b10 goalItem" style="width:70%; height: 75px" (click)="showGoalExpense(goal)"> -->
      <!-- <mat-card  #menuTrigger="matMenuTrigger"  [matMenuTriggerFor]="menu" [style.background]="'linear-gradient(0.25turn,'+  goal.color +')'" [ngClass]="goal.goalId?'activeGoal':'nonActiveGoal'" *ngFor="let goal of goals; let i = index" class="pointer m-b10 goalItem" style="width:70%; height: 75px" (click)="showGoalExpense(goal)"> -->
      <mat-card [style.background]="'linear-gradient(0.25turn,'+  goal.color +')'" [ngClass]="goal.goalId?'activeGoal':'nonActiveGoal'" *ngFor="let goal of goals; let i = index" class="pointer m-b10 goalItem" style="width:70%; height: 75px" (click)="showGoalExpense(goal)">
        <mat-card-content >     
          <div class="flex-row-container">        
            <div class="flex-col-container wd-20">
              <span class="font20">{{goal.goalDesc | uppercase}}</span>            
              <span class="font14" *ngIf="goal.GoalSummary && goal.GoalSummary.startYr>0">{{goal.GoalSummary.startYr }} - {{goal.GoalSummary.endYr}}</span>            
            </div>
            <div class="flex-col-container wd-30" *ngIf="goal.goalId && !(goal.GoalSummary && goal.GoalSummary && goal.GoalSummary.totalAmtPV>=0)">
              <mat-spinner *ngIf="showLevel2Progress" [diameter]="30" mode="indeterminate" value="30"></mat-spinner>              
            </div>
            <div class="flex-col-container wd-40" *ngIf="goal.GoalSummary">
              <span class="font26" *ngIf="goal.GoalSummary && goal.GoalSummary.totalAmtPV>0">{{goal.GoalSummary.totalAmtPV | currency:'USD': 'symbol' : '1.0-0'}}</span>
              <span class="font14 text-truncate" *ngIf="goal.GoalSummary && goal.GoalSummary.totalAmtPV>0">Cost of {{goal.goalDesc | uppercase}} goal in today's dollars</span>
              <span class="font14 red-text" *ngIf="goal.GoalSummary && goal.GoalSummary.totalAmtPV===0">{{goalExpNotIncludedMsg}}</span>
            </div>
            <div class="flex-col-container wd-15" *ngIf="goal.GoalSummary && goal.GoalSummary.totalAmtPV>0">
              <span class="font26" style="align-self:flex-end">{{goal.GoalSummary.fundingRatio | number : '1.2-2'}}%</span>
              <span class="font14" style="align-self:flex-end">Funding Ratio</span>              
              <!-- <span class="font14" style="align-self:flex-end">Funded</span>               -->
            </div>
            <!-- <div class="flex-col-container wd-50" *ngIf="!goal.goalId">
              <span class="font14 red-text">Goal is not defined</span>
            </div> -->
          </div>
        </mat-card-content>
    </mat-card>  
  </div>
</div>
<div  *ngIf="showDetails"  class="flex-col-container" [@fadeSlideGrowKeyframe]> <!-- Details Start -->
  <div class="flex-row-container m-15">
    <mat-icon class="pointer font50" aria-hidden="false" (click)="closeDetailsOverlay()">keyboard_arrow_left</mat-icon>
    <div *ngIf="selectedGoalSummary" class="flex-row-container wd-100 m-l40" style="height:60px;">
      <div class="flex-col-container wd-12 p-10" [style.background]="'linear-gradient(0.25turn,'+  selectedGoalSummary.color +')'" >
        <span class="font20">{{selectedGoalSummary && selectedGoalSummary.goalDesc | uppercase}}</span>                    
        <span class="font14" *ngIf="selectedGoalSummary && selectedGoalSummary.GoalSummary && selectedGoalSummary.GoalSummary.startYr>0">{{selectedGoalSummary.GoalSummary.startYr }} - {{selectedGoalSummary.GoalSummary.endYr}}</span>            
      </div>
      <div class="flex-col-container wd-22 p-10"  *ngIf="selectedGoalSummary && selectedGoalSummary.goalId && !(selectedGoalSummary.GoalSummary && selectedGoalSummary.GoalSummary.totalAmtPV>=0)">
        <mat-spinner  [diameter]="30" mode="indeterminate" value="30"></mat-spinner>              
      </div>
      <div class="flex-col-container wd-22 p-10" *ngIf="selectedGoalSummary && selectedGoalSummary.GoalSummary">
        <span class="font26" *ngIf="selectedGoalSummary.GoalSummary && selectedGoalSummary.GoalSummary.totalAmtPV>0">{{selectedGoalSummary.GoalSummary.totalAmtPV | currency:'USD': 'symbol' : '1.0-0'}}</span>
        <span class="font14" *ngIf="selectedGoalSummary.GoalSummary && selectedGoalSummary.GoalSummary.totalAmtPV>0">Cost of {{selectedGoalSummary.goalDesc | uppercase}} goal in today's dollars</span>
        <span class="font14 red-text" *ngIf="selectedGoalSummary.GoalSummary && selectedGoalSummary.GoalSummary.totalAmtPV===0">{{goalExpNotIncludedMsg}}</span>
      </div>
      <div *ngIf="selectedGoalSummary.GoalSummary && selectedGoalSummary.GoalSummary.totalAmtPV>0" class="flex-col-container wd-12 p-10">
        <span class="font26" style="align-self:flex-end">{{selectedGoalSummary.GoalSummary.fundingRatio | number : '1.2-2'}}%</span>
        <span class="font14" style="align-self:flex-end">Funding Ratio</span>              
        <!-- <span class="font14" style="align-self:flex-end">Funded</span>               -->
      </div>
    </div>
    <div *ngIf="!selectedGoalSummary" class="flex-row-container wd-100 m-l40" style="height:60px">
      <div class="flex-col-container wd-50">
        <!-- <mat-spinner  [diameter]="30" mode="indeterminate" value="30"></mat-spinner>               -->
      </div>      
    </div>
    <!-- <span class="water-mark m-r25">DRAFT</span> -->
    <div #editGoal>
      <mat-icon class="pointer font20" style="width:24px; height:24px" matTooltipPosition ="left" matTooltipClass="tooltip" [matTooltip]="!showEdit?'Edit Goal Expenses':''" (click)="showHideEdit()">{{showEdit?'close':'edit'}}</mat-icon>      
    </div>   
  </div>    
  <gp-goal-expense *ngIf="selectedGoalSummary"  [GoalId]="selectedGoalId" [Refresh]="refreshGoalExpense" ></gp-goal-expense>  
  <div  *ngIf="!selectedGoalSummary" class="flex-col-center m-t50">   
    <!-- <mat-spinner [diameter]="30" mode="indeterminate" value="30"></mat-spinner>               -->
    <!-- <div class="loader"></div> -->
    <!-- <div class="chartLoading">
      <div class="bar1"></div>
      <div class="bar2"></div>
      <div class="bar3"></div>
      <div class="bar4"></div>
      <div class="bar5"></div>
      <div class="bar6"></div>
    </div> -->
    <gp-chart-loading-animation></gp-chart-loading-animation>
  </div>
  <div *ngIf="showEdit" class="edit-container-pos" [@fadeInGrow] [ngStyle]="{'left.px': editGoal.offsetLeft-410, 'top.px': editGoal.offsetTop+10}">
    <div class="edit-container">
      <!-- <div class="flex-row-container edit-container__header"> 
          <span class="B flex-1 font20">Expenses</span>
          <mat-icon class="pointer flex-col-end" (click)="showHideEdit()">close</mat-icon>
      </div> -->
      <div class="edit-container__content">
        <gp-expense-list ViewMode="SMALL" [GoalId]="selectedGoalSummary && selectedGoalSummary.goalId" (UpdateExpense)="refreshMe()"></gp-expense-list>
      </div>    
    </div>
  </div>  
</div> <!-- Details End -->



<!-- [ngStyle]="{'height.px': container.offsetHeight}" -->